import FilterPills from './FilterPills';

export default FilterPills;
